import { Text } from 'common-components'
import { COLORS } from 'consts/colors'
import styled from 'styled-components'
import { customizeHorizontalScrollbarThumbMixin } from 'styles/mixins'

export const CustomText = styled(Text)`
  .highlighted {
    color: ${COLORS.secondarySemiDark};
    font-weight: 500;
    font-size: 12px;
  }
`

export const UploadAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0 4px;
  overflow-x: scroll;
  ${customizeHorizontalScrollbarThumbMixin()}
`
